import { useMedia } from "react-use";
import { atom, useRecoilValue, useSetRecoilState } from "recoil";
import {
  BREAKPOINTS,
  TBreakpointLabels,
} from "../utils/constants/hooks/breakpoints";
import { useXoraiaValue } from "./useXoraia";

export const USE_BREAKPOINTS = atom<TBreakpointLabels>({
  key: "USE_BREAKPOINTS",
  default: "all",
});

export const useBreakpoint = (): TBreakpointLabels => {
  const { env } = useXoraiaValue();
  const breakpoint = useRecoilValue(USE_BREAKPOINTS);

  const mobile = useMedia(
    `(max-width: ${BREAKPOINTS.mobile.width ?? 0}px)`,
    false
  );

  const tablet = useMedia(
    `(max-width: ${BREAKPOINTS.tablet.width ?? 0}px)`,
    false
  );

  const desktop = useMedia(
    `(max-width: ${BREAKPOINTS.desktop.width ?? 0}px)`,
    false
  );

  if (env === "prod") {
    if (mobile) {
      return "mobile";
    }

    if (tablet) {
      return "tablet";
    }

    if (desktop) {
      return "desktop";
    }
  }

  return breakpoint;
};

export const useBreakpointUpdater = () => useSetRecoilState(USE_BREAKPOINTS);
